var _polygon, _path, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlineSlotBooking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.22,334.53a135.25,135.25,0,0,0-17.37-106.9c-5.24-8-11.53-15.63-19.81-20.44s-18.86-6.43-27.52-2.35c-9.85,4.64-15.15,15.18-20.92,24.41s-14.36,18.62-25.24,18.2c-6.48-.25-12.24-4-17.47-7.84-53.57-39.25-91.75-100.08-152.76-126.31-13.5-5.81-29.38-9.62-42.59-3.17C83.06,117.2,76.47,134.42,75,150.47c-2.33,25,4.54,50.21,16.3,72.36s28.26,41.45,46,59.19c45.9,46,103,83.36,167,94.12,21.44,3.6,43.74,4.13,64.68-1.75s40.43-18.67,51.58-37.35C420.47,338.64,421.22,334.53,421.22,334.53Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.22,334.53a135.25,135.25,0,0,0-17.37-106.9c-5.24-8-11.53-15.63-19.81-20.44s-18.86-6.43-27.52-2.35c-9.85,4.64-15.15,15.18-20.92,24.41s-14.36,18.62-25.24,18.2c-6.48-.25-12.24-4-17.47-7.84-53.57-39.25-91.75-100.08-152.76-126.31-13.5-5.81-29.38-9.62-42.59-3.17C83.06,117.2,76.47,134.42,75,150.47c-2.33,25,4.54,50.21,16.3,72.36s28.26,41.45,46,59.19c45.9,46,103,83.36,167,94.12,21.44,3.6,43.74,4.13,64.68-1.75s40.43-18.67,51.58-37.35C420.47,338.64,421.22,334.53,421.22,334.53Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348,367.34s4,.92,5.86,5.9,7.52,8.07,11.17,7.89c1.47-.07,2.85.62,4.47,1.56l1.41.81c-.06-.49-.11-1-.14-1.53-.39-.3-.78-.63-1.16-1a3.07,3.07,0,0,0-.26-.25c-4.4-4.23-4.52-8.68-9.65-12.68S348,367.34,348,367.34Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.7,362.92a9.13,9.13,0,0,0-5,6.67c-1.13,5.19-6.31,9.05-10,9.38-1.46.14-2.73,1-4.2,2.18-.41.31-.83.65-1.28,1,0-.5,0-1-.08-1.54.35-.36.68-.73,1-1.13.07-.1.15-.19.22-.28,3.76-4.81,3.26-9.23,7.77-13.92S390.7,362.92,390.7,362.92Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,381.15a28.43,28.43,0,0,1-.86,8.27c-2.47,9.6-2.72,6.05-2.72,6.05s2.38-9,2.3-13.31c0-.5,0-1-.08-1.54a22.69,22.69,0,0,0-1.15-5.61c-2.61-7.54-7.82-9.87-9.88-18s5.08-13.86,5.08-13.86-1,5.08,3.84,9.74,5.49,12.76,3.43,16.88c-1.2,2.4-.44,5.41-.09,9.41C371.51,379.83,371.55,380.48,371.58,381.15Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,422.12H360a3.41,3.41,0,0,1-3.38-2.95l-4.26-31.61h31.25l-4.27,31.61A3.41,3.41,0,0,1,376,422.12Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.22,387.45v5.81h-3.37l-3.5,25.9a3.39,3.39,0,0,1-3.37,2.95H360a3.41,3.41,0,0,1-3.37-2.95l-3.5-25.9h-3.88v-5.81Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.22,387.45v5.81h-3.37l-3.5,25.9a3.39,3.39,0,0,1-3.37,2.95H360a3.41,3.41,0,0,1-3.37-2.95l-3.5-25.9h-3.88v-5.81Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.45,321.89a3.93,3.93,0,0,1-3.85,3.54,3.19,3.19,0,0,1-3.23-3.54,4,4,0,0,1,3.85-3.54A3.19,3.19,0,0,1,196.45,321.89Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.77,319.48a.71.71,0,0,1-.67-.82c.18-2-1.89-3.63-4.71-3.63s-5.24,2.42-5.34,3.63a.88.88,0,0,1-.82.82.71.71,0,0,1-.67-.82c.21-2.38,3.47-5.28,7-5.28s6.31,2.32,6.05,5.28A.88.88,0,0,1,198.77,319.48Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74,314.84a.71.71,0,0,1-.67-.82c.17-2-2.68-3.63-6.36-3.63-3.86,0-6.9,2.54-7,3.63a.88.88,0,0,1-.82.82.71.71,0,0,1-.67-.82c.21-2.38,4.23-5.28,8.63-5.28,4.65,0,8,2.27,7.7,5.28A.88.88,0,0,1,200.74,314.84Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67,310.6a.71.71,0,0,1-.67-.83c.15-1.75-3-3.62-8-3.62s-8.56,2.69-8.64,3.62a.87.87,0,0,1-.81.83.72.72,0,0,1-.68-.83c.21-2.37,5-5.27,10.28-5.27,5.68,0,9.62,2.22,9.35,5.27A.88.88,0,0,1,202.67,310.6Z",
    style: {
      fill: "#FF7200"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "374.6 271.96 109.14 271.96 123.86 103.67 389.32 103.67 374.6 271.96",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,285.13H109.35a12.12,12.12,0,0,1-12.26-13.44l14.63-167.23A15,15,0,0,1,126.34,91H387.93a12.12,12.12,0,0,1,12.26,13.44L385.56,271.69A15,15,0,0,1,371,285.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.99 271.96 120.24 271.96 134.97 103.67 385.71 103.67 370.99 271.96",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.94 272.02 120.22 272.02 134.94 103.74 385.66 103.74 370.94 272.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.8 125.07 133.07 125.07 134.94 103.74 385.66 103.74 383.8 125.07",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.93,
    cy: 176.37,
    rx: 7.96,
    ry: 7.29,
    transform: "translate(-54.8 216.24) rotate(-43.75)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.15,
    cy: 208.21,
    rx: 7.96,
    ry: 7.29,
    transform: "matrix(0.72, -0.69, 0.69, 0.72, -104.24, 156.79)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.89,223.85a8.49,8.49,0,0,1-8.29,7.62,6.87,6.87,0,0,1-6.95-7.62,8.49,8.49,0,0,1,8.29-7.62A6.87,6.87,0,0,1,223.89,223.85Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,163.78l.71-1.33a3.77,3.77,0,0,0,2,.63c.75,0,1.06-.21,1.09-.52.09-1-3.61-.28-3.4-2.65.1-1.14,1.11-2.08,3-2.08a4.57,4.57,0,0,1,2.27.56l-.67,1.35a3.55,3.55,0,0,0-1.73-.5c-.76,0-1.06.26-1.09.58-.08,1,3.61.24,3.41,2.6-.1,1.12-1.12,2.07-3,2.07A4.69,4.69,0,0,1,142.75,163.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.24,164.36l.27-3.39-1.88,2.76h-.81l-1.4-2.67-.29,3.3h-1.67L168,158h1.49l1.92,3.7L174,158h1.49l-.54,6.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,159.4h-2l.13-1.44h5.73l-.12,1.44h-2l-.44,5h-1.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.08,158l-2.63,6.4h-1.94l-.88-3.89L220,164.36h-1.94l-1.52-6.4h1.87l.93,4.09,1.71-4.09h1.66l.93,4.12,1.71-4.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.19,159.4h-2l.13-1.44h5.73L246,159.4H244l-.44,5h-1.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.54,159.36l-.12,1.41h2.83l-.13,1.4H266.3l-.19,2.19H264.3l.56-6.4h5l-.13,1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.8,163.78l.72-1.33a3.77,3.77,0,0,0,2.05.63c.75,0,1.06-.21,1.09-.52.09-1-3.61-.28-3.41-2.65.1-1.14,1.12-2.08,3-2.08a4.57,4.57,0,0,1,2.27.56l-.67,1.35a3.58,3.58,0,0,0-1.73-.5c-.76,0-1.06.26-1.09.58-.08,1,3.61.24,3.4,2.6-.09,1.12-1.11,2.07-3,2.07A4.76,4.76,0,0,1,287.8,163.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,173.72l-.56,6.4h-1.81l.44-5h-1.19l.12-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.85,178.68l-.13,1.44h-5l.1-1.14,2.59-2.24c.56-.47.66-.76.68-1s-.22-.66-.77-.66a1.44,1.44,0,0,0-1.19.62l-1.28-.75a3.23,3.23,0,0,1,2.77-1.33c1.47,0,2.42.76,2.31,1.95a2.83,2.83,0,0,1-1.26,2l-1.31,1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,178.11c-.1,1.09-1,2.13-3,2.13a4.62,4.62,0,0,1-2.43-.63l.78-1.36a3,3,0,0,0,1.73.53c.61,0,1-.24,1.07-.67s-.23-.62-.92-.62h-.76l.1-1.14,1.25-1.23H239.1l.13-1.4h4.62l-.1,1.13-1.45,1.43A1.66,1.66,0,0,1,243.79,178.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.73,178.89h-1l-.11,1.23h-1.76l.1-1.23h-3.38l.11-1.18,3.22-4h1.87l-2.93,3.74h1.3l.09-1.09H268l-.1,1.09h1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,178.06c-.1,1.14-1.05,2.18-3,2.18a4.56,4.56,0,0,1-2.42-.63l.77-1.36a3,3,0,0,0,1.73.53c.61,0,1-.25,1.08-.67s-.21-.65-1.19-.65H287l.64-3.74h4.08l-.12,1.4H289l-.16.93h.43C291.14,176.05,291.8,176.93,291.7,178.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.71,193.82A2.52,2.52,0,0,1,143,196c-1.79,0-2.87-1.08-2.69-3.15a3.56,3.56,0,0,1,3.71-3.5,3.39,3.39,0,0,1,1.84.46l-.77,1.3a1.89,1.89,0,0,0-1.15-.33,1.67,1.67,0,0,0-1.75,1.49,2.29,2.29,0,0,1,1.49-.47A1.85,1.85,0,0,1,145.71,193.82Zm-1.76.08a.72.72,0,0,0-.81-.8.89.89,0,0,0-.95.81c-.05.47.27.8.82.8A.88.88,0,0,0,144,193.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.13,189.48l-.1,1.13-2.71,5.26h-2l2.59-5h-1.68l-.09,1h-1.54l.21-2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.18,194c-.1,1.23-1.3,2-3,2s-2.71-.78-2.6-2a1.82,1.82,0,0,1,1-1.49,1.39,1.39,0,0,1-.57-1.29c.1-1.13,1.2-1.86,2.71-1.86s2.49.73,2.39,1.86a1.72,1.72,0,0,1-.8,1.29A1.49,1.49,0,0,1,195.18,194Zm-1.81-.05c0-.5-.32-.8-.89-.8a.91.91,0,0,0-1,.8c0,.49.31.79.89.79A.92.92,0,0,0,193.37,193.94Zm-1.49-2.65c0,.42.24.67.7.67a.75.75,0,0,0,.83-.67c0-.42-.26-.67-.71-.67A.75.75,0,0,0,191.88,191.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,192.5a3.56,3.56,0,0,1-3.72,3.5,3.38,3.38,0,0,1-1.83-.46l.77-1.3a1.89,1.89,0,0,0,1.15.33,1.68,1.68,0,0,0,1.74-1.48,2.32,2.32,0,0,1-1.48.46,1.85,1.85,0,0,1-2-2,2.52,2.52,0,0,1,2.69-2.18C218.11,189.35,219.19,190.43,219,192.5Zm-1.87-1.06c0-.47-.27-.8-.82-.8a.88.88,0,0,0-.94.81.72.72,0,0,0,.81.8A.89.89,0,0,0,217.14,191.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.61,189.48l-.56,6.39h-1.81l.44-5h-1.19l.12-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.29,192.67c.18-2.11,1.48-3.32,3.12-3.32s2.7,1.21,2.52,3.32-1.48,3.33-3.11,3.33S241.11,194.79,241.29,192.67Zm3.82,0c.12-1.34-.26-1.84-.83-1.84s-1.05.5-1.17,1.84.26,1.85.84,1.85S245,194,245.11,192.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,189.48l-.56,6.39h-1.81l.44-5h-1.19l.13-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.22,189.48l-.56,6.39h-1.81l.44-5H265.1l.12-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.42,189.48l-.56,6.39h-1.81l.44-5H285.3l.12-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.89,194.44l-.13,1.43h-5l.1-1.13,2.59-2.24c.56-.47.66-.77.68-1,0-.41-.22-.66-.77-.66a1.44,1.44,0,0,0-1.19.62l-1.28-.75a3.23,3.23,0,0,1,2.77-1.33c1.47,0,2.42.76,2.31,1.94a2.82,2.82,0,0,1-1.26,2l-1.31,1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,205.23l-.56,6.4h-1.81l.44-5h-1.19l.12-1.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,209.63c-.09,1.08-1,2.13-3,2.13a4.51,4.51,0,0,1-2.43-.64l.78-1.36a3,3,0,0,0,1.72.53c.62,0,1-.23,1.08-.66s-.23-.63-.93-.63H144l.1-1.14,1.25-1.23H142.8l.12-1.4h4.63l-.1,1.13L146,207.79A1.65,1.65,0,0,1,147.48,209.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3,205.23l-.56,6.4h-1.81l.43-5h-1.18l.12-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,210.4h-1l-.11,1.23H170l.1-1.23h-3.38l.1-1.18,3.22-4h1.88L169,209h1.29l.1-1.09h1.71L172,209h1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.42,205.23l-.56,6.4h-1.81l.44-5H188.3l.12-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,209.57c-.1,1.14-1.05,2.19-3,2.19a4.45,4.45,0,0,1-2.42-.64l.77-1.36a3,3,0,0,0,1.72.53c.62,0,1-.24,1.09-.67S195,209,194,209h-1.74l.65-3.74H197l-.13,1.4h-2.57l-.17.93h.43C196.47,207.56,197.13,208.44,197,209.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.32,205.23l-.56,6.4H213l.43-5H212.2l.13-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.38,209.57a2.53,2.53,0,0,1-2.7,2.19c-1.79,0-2.87-1.08-2.69-3.16a3.56,3.56,0,0,1,3.71-3.5,3.39,3.39,0,0,1,1.84.47l-.77,1.3a1.84,1.84,0,0,0-1.15-.33,1.67,1.67,0,0,0-1.75,1.49,2.3,2.3,0,0,1,1.49-.48A1.86,1.86,0,0,1,221.38,209.57Zm-1.76.08a.72.72,0,0,0-.81-.8.91.91,0,0,0-1,.81.73.73,0,0,0,.83.81A.88.88,0,0,0,219.62,209.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.23,205.23l-.56,6.4h-1.81l.44-5h-1.19l.12-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.39,205.23l-.1,1.13-2.71,5.27h-2l2.59-5h-1.68l-.09,1h-1.54l.21-2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.13,205.23l-.55,6.4h-1.81l.43-5H260l.13-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.22,209.74c-.1,1.23-1.3,2-3,2s-2.71-.79-2.6-2a1.85,1.85,0,0,1,1-1.49,1.38,1.38,0,0,1-.57-1.28c.1-1.14,1.2-1.87,2.71-1.87s2.49.73,2.39,1.87a1.72,1.72,0,0,1-.8,1.28A1.5,1.5,0,0,1,269.22,209.74Zm-1.81-.05c0-.49-.32-.79-.89-.79a.91.91,0,0,0-1,.79c0,.49.31.8.89.8A.93.93,0,0,0,267.41,209.69Zm-1.49-2.64c0,.42.24.67.7.67a.75.75,0,0,0,.83-.67c0-.43-.26-.68-.71-.68A.75.75,0,0,0,265.92,207.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,205.23l-.56,6.4h-1.81l.44-5h-1.19l.12-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.05,208.25a3.56,3.56,0,0,1-3.72,3.51,3.38,3.38,0,0,1-1.83-.47l.77-1.3a1.82,1.82,0,0,0,1.15.33,1.67,1.67,0,0,0,1.74-1.48,2.32,2.32,0,0,1-1.48.47,1.86,1.86,0,0,1-2-2,2.52,2.52,0,0,1,2.69-2.19C292.15,205.1,293.23,206.18,293.05,208.25Zm-1.87-1.05c.05-.48-.27-.81-.82-.81a.88.88,0,0,0-.94.81.72.72,0,0,0,.81.81A.89.89,0,0,0,291.18,207.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.37,226l-.12,1.43h-5l.1-1.13L140,224c.56-.48.66-.77.68-1s-.22-.66-.77-.66a1.44,1.44,0,0,0-1.19.62l-1.28-.75a3.24,3.24,0,0,1,2.77-1.33c1.47,0,2.42.76,2.31,1.94a2.83,2.83,0,0,1-1.26,2L139.9,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.05,224.18c.18-2.11,1.48-3.32,3.12-3.32s2.7,1.21,2.52,3.32-1.48,3.33-3.11,3.33S142.87,226.29,143.05,224.18Zm3.82,0c.12-1.34-.26-1.84-.83-1.84s-1,.5-1.17,1.84.26,1.85.84,1.85S146.75,225.53,146.87,224.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.69,226l-.13,1.43h-5l.1-1.13,2.59-2.24c.55-.48.65-.77.67-1s-.21-.66-.76-.66a1.44,1.44,0,0,0-1.2.62l-1.28-.75a3.25,3.25,0,0,1,2.77-1.33c1.47,0,2.42.76,2.32,1.94a2.85,2.85,0,0,1-1.27,2l-1.3,1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4,221l-.56,6.4H168l.43-5h-1.18l.12-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.81,226l-.13,1.43h-5l.1-1.13,2.59-2.24c.56-.48.66-.77.68-1s-.22-.66-.77-.66a1.44,1.44,0,0,0-1.19.62l-1.28-.75a3.24,3.24,0,0,1,2.77-1.33c1.47,0,2.42.76,2.31,1.94a2.83,2.83,0,0,1-1.26,2L189.34,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,226l-.13,1.43h-5l.1-1.13,2.59-2.24c.55-.48.65-.77.68-1s-.22-.66-.77-.66a1.47,1.47,0,0,0-1.2.62l-1.27-.75a3.22,3.22,0,0,1,2.76-1.33c1.48,0,2.42.76,2.32,1.94a2.82,2.82,0,0,1-1.27,2l-1.3,1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.71,226l-.12,1.43h-5l.1-1.13L213.3,224c.55-.48.65-.77.67-1s-.21-.66-.76-.66a1.44,1.44,0,0,0-1.2.62l-1.28-.75a3.25,3.25,0,0,1,2.77-1.33c1.47,0,2.42.76,2.32,1.94a2.85,2.85,0,0,1-1.27,2l-1.3,1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,225.38c-.09,1.09-1,2.13-3,2.13a4.6,4.6,0,0,1-2.43-.63l.78-1.36a3,3,0,0,0,1.72.53c.62,0,1-.24,1.08-.67s-.23-.62-.93-.62h-.76l.1-1.14,1.25-1.24h-2.52l.12-1.4h4.63l-.1,1.14-1.45,1.42A1.66,1.66,0,0,1,221.22,225.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.62,226l-.13,1.43h-5l.1-1.13L237.2,224c.56-.48.66-.77.68-1s-.22-.66-.77-.66a1.44,1.44,0,0,0-1.19.62l-1.28-.75a3.23,3.23,0,0,1,2.77-1.33c1.47,0,2.42.76,2.31,1.94a2.83,2.83,0,0,1-1.26,2L237.15,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.12,226.16h-1l-.11,1.22H243.3l.11-1.22H240l.1-1.18,3.22-4h1.87l-2.93,3.74h1.3l.09-1.08h1.71l-.09,1.08h.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,226l-.12,1.43h-5l.1-1.13,2.59-2.24c.55-.48.65-.77.67-1s-.21-.66-.76-.66a1.44,1.44,0,0,0-1.2.62l-1.28-.75a3.25,3.25,0,0,1,2.77-1.33c1.47,0,2.42.76,2.32,1.94a2.85,2.85,0,0,1-1.27,2l-1.3,1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.14,225.33c-.1,1.14-1.05,2.18-3,2.18a4.54,4.54,0,0,1-2.42-.63l.77-1.36a3,3,0,0,0,1.72.53c.62,0,1-.25,1.09-.68s-.21-.65-1.19-.65h-1.74L265,221h4.08l-.13,1.4h-2.57l-.17.94h.43C268.58,223.32,269.24,224.19,269.14,225.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.43,226l-.13,1.43h-5l.1-1.13L285,224c.56-.48.65-.77.68-1s-.22-.66-.77-.66a1.44,1.44,0,0,0-1.19.62l-1.28-.75a3.23,3.23,0,0,1,2.77-1.33c1.47,0,2.42.76,2.31,1.94a2.83,2.83,0,0,1-1.26,2L285,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.48,225.33a2.52,2.52,0,0,1-2.7,2.18c-1.79,0-2.87-1.08-2.69-3.15a3.56,3.56,0,0,1,3.71-3.5,3.39,3.39,0,0,1,1.84.46l-.77,1.3a1.89,1.89,0,0,0-1.15-.33,1.67,1.67,0,0,0-1.75,1.49,2.31,2.31,0,0,1,1.49-.47A1.85,1.85,0,0,1,293.48,225.33Zm-1.76.08a.72.72,0,0,0-.81-.81.89.89,0,0,0-1,.82c0,.47.27.8.82.8A.88.88,0,0,0,291.72,225.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,241.7l-.12,1.44h-5L136,242l2.59-2.23c.55-.48.65-.77.67-1s-.22-.65-.76-.65a1.42,1.42,0,0,0-1.2.62L136,238a3.23,3.23,0,0,1,2.77-1.34c1.47,0,2.42.76,2.31,1.95a2.8,2.8,0,0,1-1.26,2l-1.31,1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.15,236.74l-.1,1.13-2.72,5.27h-2l2.59-5h-1.68l-.09,1h-1.54l.21-2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.31,241.7l-.13,1.44h-5l.1-1.14,2.59-2.23c.55-.48.65-.77.68-1s-.22-.65-.77-.65a1.44,1.44,0,0,0-1.2.62l-1.27-.75a3.2,3.2,0,0,1,2.76-1.34c1.48,0,2.42.76,2.32,1.95a2.85,2.85,0,0,1-1.27,2l-1.3,1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.4,241.26c-.11,1.22-1.3,2-3,2s-2.71-.79-2.61-2a1.84,1.84,0,0,1,1-1.49,1.38,1.38,0,0,1-.57-1.29c.09-1.14,1.2-1.87,2.71-1.87s2.48.73,2.39,1.87a1.73,1.73,0,0,1-.8,1.29A1.5,1.5,0,0,1,171.4,241.26Zm-1.81-.06c0-.49-.32-.79-.89-.79a.91.91,0,0,0-1,.79c0,.49.31.8.89.8A.93.93,0,0,0,169.59,241.2Zm-1.49-2.64c0,.42.24.67.7.67a.75.75,0,0,0,.83-.67c0-.43-.27-.68-.71-.68A.75.75,0,0,0,168.1,238.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.43,241.7l-.12,1.44h-5l.09-1.14,2.6-2.23c.55-.48.65-.77.67-1s-.22-.65-.76-.65a1.42,1.42,0,0,0-1.2.62l-1.28-.75a3.23,3.23,0,0,1,2.77-1.34c1.47,0,2.42.76,2.31,1.95a2.8,2.8,0,0,1-1.26,2L188,241.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.45,239.77a3.56,3.56,0,0,1-3.72,3.5,3.38,3.38,0,0,1-1.83-.47l.77-1.3a1.82,1.82,0,0,0,1.15.33,1.67,1.67,0,0,0,1.74-1.48,2.36,2.36,0,0,1-1.48.47,1.85,1.85,0,0,1-2-2,2.52,2.52,0,0,1,2.69-2.19C195.55,236.61,196.63,237.69,196.45,239.77Zm-1.87-1.06a.73.73,0,0,0-.82-.81.88.88,0,0,0-.94.81.71.71,0,0,0,.8.81A.9.9,0,0,0,194.58,238.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,241.14c-.1,1.08-1.05,2.13-3,2.13a4.65,4.65,0,0,1-2.43-.63l.78-1.37a3,3,0,0,0,1.73.53c.61,0,1-.23,1.07-.66s-.23-.62-.92-.62h-.76l.1-1.15,1.25-1.23h-2.52l.12-1.4h4.62l-.1,1.13-1.45,1.43A1.66,1.66,0,0,1,214.37,241.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.06,239.94c.19-2.11,1.48-3.33,3.12-3.33s2.7,1.22,2.52,3.33-1.48,3.33-3.11,3.33S214.88,242.05,215.06,239.94Zm3.82,0c.12-1.34-.26-1.85-.83-1.85s-1.05.51-1.17,1.85.26,1.85.84,1.85S218.76,241.28,218.88,239.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.2 134.48 144.82 137.92 147.56 141.72 148.2 134.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.61 134.48 299.38 137.92 295.97 141.72 296.61 134.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.24 141.72 191.57 141.72 192.2 134.48 252.87 134.48 252.24 141.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.94 272.02 302.09 272.02 314.95 125.07 383.8 125.07 370.94 272.02",
    style: {
      fill: "#FF7200"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "370.94 272.02 302.09 272.02 314.95 125.07 383.8 125.07 370.94 272.02"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327,184h-6.7a2.74,2.74,0,0,1-2.78-3l2.14-24.4a3.37,3.37,0,0,1,3.3-3h6.71a2.75,2.75,0,0,1,2.78,3L330.32,181A3.38,3.38,0,0,1,327,184Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,171.13c-.1,1.09-1,2.13-3,2.13a4.62,4.62,0,0,1-2.43-.63l.78-1.36a3,3,0,0,0,1.73.53c.61,0,1-.24,1.07-.67s-.23-.62-.92-.62h-.76l.1-1.14,1.25-1.24h-2.53l.13-1.4h4.62l-.1,1.14-1.45,1.42A1.66,1.66,0,0,1,327,171.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.55,184H335.78a2.74,2.74,0,0,1-2.78-3l2.13-24.4a3.39,3.39,0,0,1,3.31-3h32.78a2.74,2.74,0,0,1,2.77,3L371.86,181A3.39,3.39,0,0,1,368.55,184Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.3,221.09H332.53a2.75,2.75,0,0,1-2.78-3l2.14-24.4a3.39,3.39,0,0,1,3.31-3H368a2.75,2.75,0,0,1,2.78,3l-2.14,24.4A3.39,3.39,0,0,1,365.3,221.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.06,258.19H329.28a2.74,2.74,0,0,1-2.77-3l2.13-24.4a3.39,3.39,0,0,1,3.31-3h32.77a2.74,2.74,0,0,1,2.78,3l-2.14,24.4A3.37,3.37,0,0,1,362.06,258.19Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.77,221.09h-6.71a2.74,2.74,0,0,1-2.77-3l2.13-24.4a3.39,3.39,0,0,1,3.31-3h6.71a2.74,2.74,0,0,1,2.77,3l-2.13,24.4A3.39,3.39,0,0,1,323.77,221.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.36,201.81l-.56,6.4H318l.44-5h-1.19l.12-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.86,206.21c-.09,1.09-1,2.13-3,2.13a4.6,4.6,0,0,1-2.43-.63l.77-1.36a3.12,3.12,0,0,0,1.73.53c.61,0,1-.24,1.07-.67s-.22-.62-.92-.62h-.76l.1-1.14,1.25-1.24h-2.52l.12-1.4h4.63l-.1,1.14-1.45,1.42A1.65,1.65,0,0,1,325.86,206.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.52,258.19h-6.7a2.74,2.74,0,0,1-2.78-3l2.13-24.4a3.39,3.39,0,0,1,3.31-3h6.71a2.75,2.75,0,0,1,2.78,3l-2.14,24.4A3.39,3.39,0,0,1,320.52,258.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.45 142.23 328.07 142.23 328.75 134.48 370.12 134.48 369.45 142.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,114.78a4.42,4.42,0,0,1,4.58-4,3.74,3.74,0,0,1,3.19,1.45l-1.5,1.26a2.06,2.06,0,0,0-1.73-.9,2.29,2.29,0,0,0-2.34,2.2,1.87,1.87,0,0,0,1.95,2.2,2.51,2.51,0,0,0,1.9-.91l1.27,1.26a4.48,4.48,0,0,1-3.44,1.45A3.59,3.59,0,0,1,226,114.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.32,117.13h-3.25l-.74,1.5h-2.22l4.07-7.7h2.15l2.73,7.7H239.8Zm-.49-1.61-.78-2.46-1.2,2.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.35,110.93h2.18l-.52,6h3.67l-.15,1.73h-5.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.72,116.94l-.15,1.69h-6.18l.67-7.7h6l-.15,1.68h-3.88l-.11,1.3h3.42l-.14,1.62h-3.42l-.13,1.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.78,110.93l-.67,7.7h-1.8l-3-4.11-.36,4.11h-2.13l.67-7.7h1.8l3,4.1.36-4.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.32,110.93H270c2.55,0,4.17,1.48,4,3.85s-2.09,3.85-4.64,3.85h-3.64Zm3,6a2.22,2.22,0,0,0,2.38-2.11,1.83,1.83,0,0,0-2-2.12h-1.37l-.37,4.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.91,117.13h-3.25l-.74,1.5H273.7l4.07-7.7h2.15l2.73,7.7h-2.26Zm-.49-1.61-.78-2.46-1.2,2.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.81,116.58h-1.18l-.18,2h-2.18l.67-7.7h3.52c2.1,0,3.33,1.08,3.17,2.85a2.84,2.84,0,0,1-1.72,2.43l1.45,2.42H288Zm.37-3.94H286l-.2,2.26H287c.91,0,1.39-.42,1.45-1.12S288.08,112.64,287.18,112.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,117.29h-1a1.44,1.44,0,0,1-1.46-1.59l.09-1a1.77,1.77,0,0,1,1.73-1.59h1a1.44,1.44,0,0,1,1.46,1.59l-.09,1A1.77,1.77,0,0,1,147,117.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3,117.29h-1a1.43,1.43,0,0,1-1.45-1.59l.09-1a1.77,1.77,0,0,1,1.73-1.59h1a1.43,1.43,0,0,1,1.45,1.59l-.08,1A1.78,1.78,0,0,1,153.3,117.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,117.29h-1a1.43,1.43,0,0,1-1.45-1.59l.09-1a1.76,1.76,0,0,1,1.72-1.59h1a1.43,1.43,0,0,1,1.45,1.59l-.09,1A1.76,1.76,0,0,1,159.57,117.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,245.75l-.13,1.43h-5l.1-1.13,2.59-2.24c.55-.48.65-.77.68-1,0-.42-.22-.66-.77-.66a1.46,1.46,0,0,0-1.2.62l-1.27-.75a3.2,3.2,0,0,1,2.76-1.34c1.47,0,2.42.76,2.32,1.95a2.85,2.85,0,0,1-1.27,2l-1.3,1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.43,245.18c-.1,1.09-1.05,2.13-3,2.13a4.62,4.62,0,0,1-2.43-.63l.78-1.36a3.07,3.07,0,0,0,1.73.53c.61,0,1-.24,1.07-.67s-.23-.62-.92-.62h-.76l.1-1.15,1.25-1.23h-2.53l.13-1.4h4.62l-.1,1.14-1.45,1.42A1.66,1.66,0,0,1,323.43,245.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.97 165.97 339.95 165.97 340.04 164.97 367.06 164.97 366.97 165.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.06 170.48 339.56 170.48 339.64 169.48 353.15 169.48 353.06 170.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.48 240.12 333.46 240.12 333.55 239.12 360.57 239.12 360.48 240.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.58 244.64 333.07 244.64 333.15 243.64 346.66 243.64 346.58 244.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.75 202.8 336.73 202.8 336.81 201.8 363.83 201.8 363.75 202.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.84 207.31 336.33 207.31 336.42 206.31 349.93 206.31 349.84 207.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.23,158.72c.59-1.42.21-2.45,1.61-2.45s.69,1,1.19,2.45c.26.71-.68.58-1.45.58S366.92,159.45,367.23,158.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.8,156.73a.42.42,0,0,1-.42-.46.52.52,0,0,1,.5-.46.41.41,0,0,1,.42.46A.5.5,0,0,1,368.8,156.73Zm.06-.68a.25.25,0,0,0-.24.22.2.2,0,0,0,.2.22.25.25,0,0,0,.24-.22A.2.2,0,0,0,368.86,156.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,196c.59-1.42.21-2.44,1.61-2.44s.69,1,1.19,2.44c.26.71-.68.59-1.45.59S363.66,196.71,364,196Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.54,194a.42.42,0,0,1-.42-.46.51.51,0,0,1,.5-.46.41.41,0,0,1,.42.46A.51.51,0,0,1,365.54,194Zm.06-.68a.25.25,0,0,0-.24.22.2.2,0,0,0,.2.22.25.25,0,0,0,.24-.22A.2.2,0,0,0,365.6,193.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.71,233.23c.59-1.42.21-2.45,1.61-2.45s.69,1,1.19,2.45c.26.7-.68.58-1.45.58S360.4,234,360.71,233.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.28,231.24a.42.42,0,0,1-.42-.46.52.52,0,0,1,.5-.46.41.41,0,0,1,.42.46A.51.51,0,0,1,362.28,231.24Zm.06-.68a.25.25,0,0,0-.24.22.2.2,0,0,0,.2.22.24.24,0,0,0,.24-.22A.2.2,0,0,0,362.34,230.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.84 91.11 104.99 285.04 122.44 285.04 173.72 91.11 156.84 91.11",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.76 91.11 131.91 285.04 166.51 285.04 217.79 91.11 183.76 91.11",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 184.37,
    r: 7.41,
    transform: "translate(-89.66 255.44) rotate(-76.72)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.43,184.37a3.71,3.71,0,1,1-3.7-3.71A3.7,3.7,0,0,1,389.43,184.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.7,118.7a1.46,1.46,0,0,1-1.42,1.31,1.18,1.18,0,0,1-1.19-1.31,1.45,1.45,0,0,1,1.42-1.3A1.17,1.17,0,0,1,337.7,118.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.14,114.82l-.63,1.07a5.5,5.5,0,0,0-2.29-.45,4.79,4.79,0,0,0-2.06.46l-.51-1.07a6.52,6.52,0,0,1,5.49,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.91,111.8l-.64,1.08a8.46,8.46,0,0,0-3.83-.8,8.37,8.37,0,0,0-3.69.86l-.5-1.06a9.57,9.57,0,0,1,4.3-1A9.42,9.42,0,0,1,340.91,111.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,108.73l-.64,1.11a11.12,11.12,0,0,0-5.39-1.12,11.87,11.87,0,0,0-5.35,1.22l-.49-1a13.32,13.32,0,0,1,5.95-1.39A12.43,12.43,0,0,1,342.69,108.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.36,120.22a5.81,5.81,0,0,1-5.87-6.43,7.17,7.17,0,0,1,7-6.43l0,.28a6.84,6.84,0,0,0-6.68,6.15,5.55,5.55,0,0,0,5.61,6.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.59,120.47h-.25a6,6,0,0,1-6.1-6.68,7.46,7.46,0,0,1,7.27-6.68h.25l-.07.78h-.25a6.57,6.57,0,0,0-6.41,5.9,5.32,5.32,0,0,0,5.38,5.9h.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.36,120.22l0-.28a6.84,6.84,0,0,0,6.68-6.15,5.55,5.55,0,0,0-5.61-6.15l0-.28a5.79,5.79,0,0,1,5.86,6.43A7.16,7.16,0,0,1,360.36,120.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.34,120.47h-.25l.07-.78h.25a6.57,6.57,0,0,0,6.41-5.9,5.32,5.32,0,0,0-5.38-5.9h-.25l.07-.78h.25a6,6,0,0,1,6.09,6.68A7.44,7.44,0,0,1,360.34,120.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.21,113.79h-.28c.18-2.08-.63-4.87-2.54-6.17l.17-.24C363.55,108.74,364.4,111.63,364.21,113.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.44,114h-.78l0-.25c.17-2-.61-4.71-2.45-6l-.19-.13.48-.66.19.13c2.06,1.4,3,4.39,2.75,6.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,120l-.14-.24a8.56,8.56,0,0,0,3.62-6.17h.29A8.93,8.93,0,0,1,360.46,120Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.35,120.35l-.36-.66.22-.13a8.26,8.26,0,0,0,3.48-6l0-.25h.78l0,.25a9.21,9.21,0,0,1-3.91,6.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,113.79h-.28a8.9,8.9,0,0,1,3.77-6.41l.13.24A8.6,8.6,0,0,0,357.92,113.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.15,114h-.78l0-.25a9.2,9.2,0,0,1,3.9-6.62l.22-.13.37.66-.22.13a8.28,8.28,0,0,0-3.49,6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.3,120c-2-1.36-2.83-4.25-2.65-6.41h.29c-.18,2.08.63,4.87,2.54,6.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.35,120.35l-.2-.13c-2.06-1.4-2.94-4.39-2.75-6.62l0-.25h.78l0,.25c-.18,2,.6,4.71,2.44,6l.2.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.51 120.08 360.23 120.08 361.33 107.5 361.62 107.5 360.51 120.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.74 120.33 359.96 120.33 361.11 107.25 361.89 107.25 360.74 120.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.53 110.58 355.88 110.58 355.91 110.3 366.55 110.3 366.53 110.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.76 110.83 355.61 110.83 355.68 110.05 366.82 110.05 366.76 110.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.19 114.04 354.62 114.04 354.64 113.76 367.21 113.76 367.19 114.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.42 114.29 354.34 114.29 354.41 113.51 367.49 113.51 367.42 114.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.78 117.49 355.42 117.49 355.44 117.21 365.81 117.21 365.78 117.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.01 117.74 355.14 117.74 355.21 116.96 366.08 116.96 366.01 117.74",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.54 410.78 254.65 404.88 236.71 387.85 229.05 394.39 247.54 410.78",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43,402.6a3.69,3.69,0,0,0-2.47.12c-.48.14-1,.3-1.42.47s-.67.25-.93.36l-.8.35a.23.23,0,0,0-.15.21.15.15,0,0,0,0,.1.28.28,0,0,0,.15.11,16.91,16.91,0,0,0,3.09.52,3.71,3.71,0,0,0,1.52-.11l.07,0a4.17,4.17,0,0,0,.81-.36,1.29,1.29,0,0,0,.47-1.11A.76.76,0,0,0,260.43,402.6Zm-.1.65a.78.78,0,0,1-.31.75,1.78,1.78,0,0,1-.81.33,4.67,4.67,0,0,1-1.22.06,13.4,13.4,0,0,1-1.89-.23l-.47-.1a12.61,12.61,0,0,1,2.65-.92,10.64,10.64,0,0,1,1.48-.25.81.81,0,0,1,.43.11A.3.3,0,0,1,260.33,403.25Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.16,398.85a1.67,1.67,0,0,0-1.13.73,2,2,0,0,0-.2.38,6.88,6.88,0,0,0-.22,3.59s0,.05,0,.05a.22.22,0,0,0,.15.18.17.17,0,0,0,.14,0,.14.14,0,0,0,.09-.05,5.7,5.7,0,0,0,.54-.55,8.77,8.77,0,0,0,.85-1.2c.62-1,1.06-2.14.79-2.73C258.07,399,257.81,398.74,257.16,398.85Zm.6.59c.17.39-.17,1.28-.67,2.16a8.51,8.51,0,0,1-1.08,1.5,6.72,6.72,0,0,1,.14-2.71,1.94,1.94,0,0,1,.26-.54,1.25,1.25,0,0,1,.69-.51l.14,0C257.66,399.24,257.74,399.4,257.76,399.44Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.73,404.45,244.79,409a.79.79,0,0,0-.42.94l2.64,8.37a1.56,1.56,0,0,0,2,1l.16-.06c15.31-5.39,20-9.2,21.61-10.07,4.56-2.49,2-5.72.29-5.32-7.64,1.83-10.2,1.36-13.51.51A8.16,8.16,0,0,0,253.73,404.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.71 387.86 245.8 395.91 238.14 402.45 229.05 394.4 236.71 387.86",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.89 402.39 245.31 391.85 242.8 387.43 229.58 398.78 233.89 402.39",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,389l-1.53,1.32-2.28,2-1.37,1.17-4,3.42-.77.66s-16.28-9.17-25.34-17c-6.21-5.37-6.77-7.36-7.43-6.86-8.75,6.66-34.65,29.68-49.34,41.66-.47.06-.95.1-1.43.14-7.84.57-14-.28-18.8-2.11-.05-6.37,5.39-21.24,5.84-22.68,0,0,21.66-21.54,56.77-39.76.34-.17.7-.32,1.06-.47s.91-.39,1.37-.55a17.67,17.67,0,0,1,5.38-1.22,11.87,11.87,0,0,1,4.57.72,17.42,17.42,0,0,1,2.43,1.07,22,22,0,0,1,2,1.18c1.08.69,2.13,1.46,3.13,2.22,2.24,1.73,19.2,23.57,28.32,33.65h0C240.11,388,240.56,388.53,241,389Z",
    style: {
      fill: "#FF7200"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241,389l-1.53,1.32-2.28,2-1.37,1.17-4,3.42-.77.66s-16.28-9.17-25.34-17c-6.21-5.37-6.77-7.36-7.43-6.86-8.75,6.66-34.65,29.68-49.34,41.66-.47.06-.95.1-1.43.14-7.84.57-14-.28-18.8-2.11-.05-6.37,5.39-21.24,5.84-22.68,0,0,21.66-21.54,56.77-39.76.34-.17.7-.32,1.06-.47s.91-.39,1.37-.55a17.67,17.67,0,0,1,5.38-1.22,11.87,11.87,0,0,1,4.57.72,17.42,17.42,0,0,1,2.43,1.07,22,22,0,0,1,2,1.18c1.08.69,2.13,1.46,3.13,2.22,2.24,1.73,19.2,23.57,28.32,33.65h0C240.11,388,240.56,388.53,241,389Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "251.64 415.26 259.35 407.74 244.43 389 235.11 394.5 251.64 415.26",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.22,405.43c-.86-.3-2.61.66-4,1.51l-.89.59,0,0-.14.1-.6.43a.23.23,0,0,0-.11.26.24.24,0,0,0,.22.18,19.59,19.59,0,0,0,2.76-.09l.6-.07a3.84,3.84,0,0,0,1.86-.64,4.53,4.53,0,0,0,.55-.43,1.35,1.35,0,0,0,.25-1.27A.87.87,0,0,0,267.22,405.43Zm0,.71a.87.87,0,0,1-.16.86,2.73,2.73,0,0,1-1.52.76,11,11,0,0,1-2.06.28c-.32,0-.66,0-1,0l.33-.26.24-.17a13,13,0,0,1,3.5-1.74.84.84,0,0,1,.47,0A.29.29,0,0,1,267.27,406.14Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.94,402.25a1.78,1.78,0,0,0-1,1c-.63,1.54.3,3.9.46,4.27,0,0,0,0,0,0v0a.25.25,0,0,0,.2.15.26.26,0,0,0,.15,0,.1.1,0,0,0,.08-.06l0,0a4.21,4.21,0,0,0,.42-.68c.74-1.39,1.43-3.71.83-4.51C263.92,402.2,263.59,402,262.94,402.25Zm-.25,4.71c-.27-.79-.75-2.46-.31-3.5a1.29,1.29,0,0,1,.61-.69l.13-.07c.43-.17.54,0,.58,0C264.13,403.32,263.47,405.68,262.69,407Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.65 387.85 250.67 396.84 241.17 402.13 234.04 393.38 243.65 387.85",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54,391.87l-1.95,1.1h0l-3.35,1.89-3,1.68h0l-3.09,1.74h0L237,399l-.74-.54-.63-.46c-.74-.55-1.76-1.32-3-2.26h0c-6.21-4.91-17.26-14.55-20.55-23.32-2.13,2.54-4.61,5.78-7.59,9.23-23.18,26.91-47.94,45.88-81.94,37.71-14.77-3.55-14.21-24-14.21-24,0-7.73,5.73-15.68,5.73-15.68l45.23,3.51c6.26-7.6,18.8-19.5,31.63-27,.3-.19.61-.37.92-.53s.77-.44,1.15-.65a51.57,51.57,0,0,1,12.3-5c.88-.21,1.75-.4,2.6-.52a24.66,24.66,0,0,1,2.66-.26h0c6.08-.28,11.36,2,14.94,8.05l23.37,33.68Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54,391.87l-1.95,1.1h0l-3.35,1.89-3,1.68h0l-3.09,1.74h0L237,399l-.74-.54-.63-.46c-.74-.55-1.76-1.32-3-2.26h0c-6.21-4.91-17.26-14.55-20.55-23.32-2.13,2.54-4.61,5.78-7.59,9.23-23.18,26.91-47.94,45.88-81.94,37.71-14.77-3.55-14.21-24-14.21-24,0-7.73,5.73-15.68,5.73-15.68l45.23,3.51c6.26-7.6,18.8-19.5,31.63-27,.3-.19.61-.37.92-.53s.77-.44,1.15-.65a51.57,51.57,0,0,1,12.3-5c.88-.21,1.75-.4,2.6-.52a24.66,24.66,0,0,1,2.66-.26h0c6.08-.28,11.36,2,14.94,8.05l23.37,33.68Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.08 401.1 250.02 393.63 248.74 388.32 231.71 396.09 235.08 401.1",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,406.93l-10.3,3.12a.86.86,0,0,0-.62.92l1.25,9.34A1.7,1.7,0,0,0,251,421.7l.18,0c17.2-2.87,22.88-6,24.73-6.66,5.29-1.79,3.17-5.68,1.3-5.57-8.43.52-11.05-.45-14.39-2A8.45,8.45,0,0,0,258.75,406.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,358.1h-32a1.48,1.48,0,0,1-1.5-1.64L175.34,336a1.82,1.82,0,0,1,1.78-1.64h32a1.48,1.48,0,0,1,1.5,1.64l-1.79,20.47A1.83,1.83,0,0,1,207.06,358.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.07 356.49 176.38 356.49 178.19 335.89 208.87 335.89 207.07 356.49",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,345.32a.91.91,0,1,1-.9-.91A.9.9,0,0,1,176.83,345.32Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.4,344.86a.45.45,0,1,1-.45-.45A.45.45,0,0,1,209.4,344.86Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,299c1.14,6.26-.52,14.65-4.93,18.76,5,9.5,12.47,18.7,19.48,26.8,9.92-15.92,1.41-26.27,1.41-26.27-6.95-1.75-6.74-4.57-5.47-9.39Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.94,315.05a7.88,7.88,0,0,1,3.54-3.74c1.52-.89,16,.78,19.55,2.48a9.5,9.5,0,0,1,4.71,4.8Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.73,293.8l6.44,3a13.26,13.26,0,0,1,.54,5.21c-.37,2.2-1.36,2.93-5,1.41h0C166.47,299.32,167.73,293.8,167.73,293.8Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,289.73l.72,1.54L174,292a1.85,1.85,0,0,1,.83,2l-.67,2.76-6.43-3,1.22-2.43c1.12-1.71,2-2.2,2.94-1.75Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.17,329.92c3.69-8.09,5.24-11.88,9.26-26.85l-5.34-.6c-5.35,14.31-11.49,20.38-11.49,20.38s-30.12-5.07-33.86-3.3c-6.06,2.86-2.82,9.11,1,10.69s25.39,5.13,35.37,3.9A6.73,6.73,0,0,0,165.17,329.92Z",
    style: {
      fill: "#cb7a63"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.37 296.26 188.35 296.28 188.34 296.27 188.37 296.26"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.62,330.06c6.06,19.59-14.11,22.41-9,53.92l-42.51-4.35c2.35-16.24,7.69-12,3.94-43.59-.32-2.67-.45-10.25,3.17-16.67a12.45,12.45,0,0,1,6.29-5.53c3.34-1.29,17,1.77,23.2,3C157.61,316.73,164.67,327.59,165.62,330.06Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.71,292.39c-.4.72-.32,1.46.13,1.71s1.13-.1,1.52-.8.32-1.46-.13-1.71S157.09,291.7,156.71,292.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,291.52l1.93.44S158.36,292.79,158,291.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.83,293.86a20.86,20.86,0,0,0,1.88,5.47,3.42,3.42,0,0,1-2.88,0Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,287.39a.48.48,0,0,0,.3-.35.47.47,0,0,0-.37-.55,4.63,4.63,0,0,0-4.1,1.13.47.47,0,1,0,.61.71l.06-.06a3.72,3.72,0,0,1,3.25-.86A.42.42,0,0,0,159.75,287.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.12,285.41c-1.15,9.69-1.85,13.77,2.1,19.57,5.94,8.72,18.12,8,22.13-1.13,3.62-8.25,4.9-22.71-3.79-28.23a13.31,13.31,0,0,0-20.44,9.79Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.59,303.27a5.46,5.46,0,0,1-1.53-2.44.21.21,0,0,1,.15-.24.21.21,0,0,1,.24.14,5.18,5.18,0,0,0,1.3,2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,282.25a4,4,0,0,1-3.58,4.06c-1.3,3.52-4.9,8.89-8.06,6.86,1.84-.06,5.2-4.23,2.36-7.49-2.08-2.38-4.9-8.63,0-10.16C157.23,274.34,162.71,278.41,162.72,282.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.23,278.3c-1.37-5.67-9.54-10.09-15.37-9.91s-11.19,3.37-15.46,7.34c-2.22,2.06-4.29,4.46-5.08,7.39s0,6.45,2.56,8.1c-9.3,9.17-2.38,12.89-1,12.26.2,2.3-1.37,3.66-3.48,5.17-1.88,1.34-2.35,2.93-3,5.14s0,5,2,6a2.65,2.65,0,0,1,1.68-3.56,6.23,6.23,0,0,0,8.27,8.15c-.92-.23-2.21-1.13-2.36-2.07a27.81,27.81,0,0,0,8.3,2.12c2.87.11,5.93-.82,7.7-3.08.11-1.64,2.33-3.28,4-3.22a3.33,3.33,0,0,1,3.11,3.21c1.82-.4,2.57-2.41,2.67-4.26a4.32,4.32,0,0,0-.85-2.75,3.86,3.86,0,0,0-2.69-1.35,3.53,3.53,0,0,1-2.09-1.66,2.74,2.74,0,0,1,.45-2.72c7.23-10.32,3.82-16.74,4.3-18s2.8.36,2.8.36C152.79,288.31,155,281.6,154.23,278.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,292.48a8.51,8.51,0,0,0,2,6.19c1.95,2.27,4.58.92,5.41-1.78.76-2.43.65-6.54-2-7.82S143.74,289.74,143.5,292.48Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.11,376.35l-1.47,3.72c-.18.28.15.61.63.66l43.78,4.5c.38,0,.72-.12.77-.36l-.58-4.17c.06-.25-.26-.51-.68-.55l-41.71-4A.79.79,0,0,0,114.11,376.35Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45,385.12l-1.16,0c-.23,0-.41-.12-.39-.26l.61-5c0-.14.22-.26.45-.26l1.16,0c.23,0,.41.12.39.27l-.61,5C152.88,385,152.68,385.12,152.45,385.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,383.34l-1.16,0c-.22,0-.4-.13-.38-.27l.61-5c0-.14.22-.25.45-.25h1.16c.22,0,.41.12.38.28l-.6,4.95C137.24,383.24,137,383.34,136.8,383.34Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,383.34l-1.16,0c-.22,0-.4-.13-.38-.27l.61-5c0-.14.22-.25.45-.25h1.16c.22,0,.41.12.38.28l-.6,4.95C137.24,383.24,137,383.34,136.8,383.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.24,328.65s-2.89,4.37,2.16,17.53l2.13,5.37h0c.7,1.78,7.18-.83,9.38-3.71h0S150.21,339.42,147.24,328.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3,355l7.88-4.73-.06,7.21s-6,4.93-8.66,1C196.46,358.5,195.57,355.74,197.3,355Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,352.58l-.33,2.62a1.86,1.86,0,0,1-1.52,1.61l-3.81.67.06-7.21,3.83.24a1.84,1.84,0,0,1,1.78,1.91A.92.92,0,0,1,210.75,352.58Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,359.64c2.66,4.76,6.71,9,11.89,10.69,6.1,2,20.14-5.93,26.52-10.94,0-2.46-.53-3.12-2.9-3.77,0,0-6.79,3.77-18.85,5-3.9.4-5.93-3.79-8.52-9.84-1.29-3-6.29-21.12-8-23.94-2.7-4.53-12.25-2.74-9.86,7.63C152.36,338.86,158.88,355.75,161.05,359.64Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36,323.5c5.76,6.8,7.58,17.78,7.58,17.78l-16.38,7.34s-9.14-17-6.46-22.2c2.1-4,5.35-6.42,9.19-6.17A8.77,8.77,0,0,1,162.36,323.5Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.55,381.76l-1.16-.12c-.22-.05-.39-.15-.36-.3l1-4.89c0-.15.24-.24.47-.22l1.16.12c.22,0,.39.16.36.3l-1,4.9A.38.38,0,0,1,119.55,381.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.2,
    y: 357.17,
    width: 1,
    height: 41.91,
    transform: "translate(-253.75 476.7) rotate(-84.46)",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineSlotBooking);
export default __webpack_public_path__ + "static/media/online-slot-booking.deab8642a2330c8c735ca7553bc40545.svg";
export { ForwardRef as ReactComponent };